interface FinalCTAProps {
  onRandevuClick?: () => void;
}

export default function FinalCTA({ onRandevuClick }: FinalCTAProps) {
  const whatsappUrl = "https://wa.me/905001234567?text=Merhaba%2C%20kampanyalar%20hakk%C4%B1nda%20bilgi%20almak%20istiyorum.";



  return (
    <section id="final-cta" className="relative py-20 md:py-28 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=luxury%20beauty%20salon%20interior%20elegant%20warm%20golden%20lighting%20marble%20surfaces%20premium%20skincare%20products%20soft%20bokeh%20background%20high%20end%20aesthetic%20professional%20photography&width=1400&height=700&seq=finalcta001&orientation=landscape"
          alt="Elora Beauty Lounge"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-[#1A0F0A]/92 via-[#1A0F0A]/85 to-[#2D1810]/90" />
      </div>

      {/* Accent lines */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#E8B86D]/50 to-transparent" />
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#E8B86D]/30 to-transparent" />

      <div className="max-w-4xl mx-auto px-6 md:px-10 text-center relative z-10">
        {/* Badge */}
        <span className="inline-block bg-[#E8B86D]/15 text-[#E8B86D] text-xs font-bold px-5 py-2 rounded-full tracking-[0.2em] uppercase mb-6 border border-[#E8B86D]/30">
          Hemen Başlayın
        </span>

        <h2
          className="font-black italic text-white leading-tight mb-5"
          style={{
            fontFamily: "'Playfair Display', serif",
            fontSize: "clamp(2rem, 5vw, 3.8rem)",
          }}
        >
          Size En Uygun Kampanyayı
          <br />
          <span
            style={{
              background: "linear-gradient(135deg, #C9943A 0%, #E8B86D 50%, #F5D08A 100%)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              backgroundClip: "text",
            }}
          >
            Birlikte Belirleyelim
          </span>
        </h2>

        <p className="text-white/60 text-base md:text-lg mb-12 max-w-xl mx-auto font-light">
          Uzman ekibimiz sizin için en doğru uygulamayı belirliyor. Ücretsiz danışmanlık için hemen iletişime geçin.
        </p>

        {/* Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12">
          <a
            href={whatsappUrl}
            target="_blank"
            rel="nofollow noopener noreferrer"
            className="bg-[#25D366] hover:bg-[#1ebe5d] text-white font-bold px-9 py-4 rounded-full text-base transition-all duration-200 cursor-pointer whitespace-nowrap flex items-center gap-3"
            style={{ fontFamily: "'Inter', sans-serif" }}
          >
            <i className="ri-whatsapp-line text-xl" />
            WhatsApp&apos;tan Yaz
          </a>
          <button
            onClick={onRandevuClick}
            className="bg-[#E8B86D] hover:bg-[#F5D08A] text-[#1A0F0A] font-bold px-9 py-4 rounded-full text-base transition-all duration-200 cursor-pointer whitespace-nowrap flex items-center gap-3"
            style={{ fontFamily: "'Inter', sans-serif" }}
          >
            <i className="ri-calendar-line text-xl" />
            Randevu Talep Et
          </button>
        </div>

        {/* Trust indicators */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-6 text-white/40 text-sm">
          <span className="flex items-center gap-2">
            <i className="ri-time-line text-[#E8B86D]" />
            Ortalama yanıt süresi: 2 dakika
          </span>
          <span className="hidden sm:block w-1 h-1 rounded-full bg-[#E8B86D]/40" />
          <span className="flex items-center gap-2">
            <i className="ri-shield-check-line text-[#E8B86D]" />
            Ücretsiz danışmanlık
          </span>
          <span className="hidden sm:block w-1 h-1 rounded-full bg-[#E8B86D]/40" />
          <span className="flex items-center gap-2">
            <i className="ri-star-line text-[#E8B86D]" />
            5.000+ mutlu müşteri
          </span>
        </div>
      </div>
    </section>
  );
}